<template>
    <div>
        <div class="signup-header row border-bottom-light row justify-content-sm-center">
            <div class="col-sm-6">
                <h5 class="color-6">1. Your company</h5>
                <h2>{{ brand }} in a nutshell.</h2>
                <h4>This will help us create your company page.</h4>
            </div>
        </div>

        <div class="row justify-content-sm-center">
            <div class="col-sm-6">
                <form class="shaded" @submit.prevent.stop="processForm" novalidate>

                    <avatar-uploader placeholder="supplier" @uploadComplete="addUploadedAvatar"></avatar-uploader>

                    <div class="form-group" :class="{ error: $v.form.companyEmail.$error }">
                        <label class="full">
                            Email (for customer contact)
                            <input v-model.trim="form.companyEmail" type="email" placeholder="Please add your email" @input="$v.form.companyEmail.$touch">
                        </label>

                        <div v-if="$v.form.companyEmail.$error" class="messages">
                            <span v-if="!$v.form.companyEmail.required">Email is required.</span>
                            <span v-if="!$v.form.companyEmail.email">Must be a valid email</span>
                        </div>
                    </div>

                    <!-- <div class="form-group" v-if="offerTypes">
                        <label class="full">Choose the best option to describe your offer</label>

                        <v-select
                            v-model="selectedOfferType"
                            :options="offerTypes"
                            placeholder="What best describes your business type?"
                            :searchable="false"
                            label="description"
                            @input="updateOfferType">
                        </v-select>
                    </div> -->

                    <div class="form-group">
                        <div class="row">

                            <div class="col-sm-6" :class="{ error: $v.form.companyPhone.$error }">
                                <label class="full">
                                    Phone (for customer contact)
                                    <input v-model="form.companyPhone" type="tel" placeholder="Please add your phone no." @input="$v.form.companyPhone.$touch">
                                </label>

                                <div v-if="$v.form.companyPhone.$error" class="messages">
                                    <span>Phone format is invalid.</span>
                                </div>
                            </div>

                            <div class="col-sm-6" >
                                <label class="full">
                                    Website
                                    <input v-model="form.website" type="tel" placeholder="www.website.com" >
                                </label>

                            </div>

                        </div>
                    </div>

                    <!-- <div class="form-group">
                        <label class="full">
                            Tagline
                            <input v-model="form.tagline" type="text" placeholder="Add a short description of your company">
                        </label>
                    </div> -->

                    <!-- <div class="form-group" :class="{ error: $v.form.companyURL.$error }">
                        <label class="full">
                            Set a unique URL to your public page (this cannot be undone)

                            <div class="d-flex align-items-center mt-2">
                                <span class="darker mr-2 fs-small">http://pluralo.com/</span>
                                <input v-model="form.companyURL" type="text" placeholder="Your company page URL" @input="$v.form.companyURL.$touch">
                            </div>
                        </label>

                        <div v-if="$v.form.companyURL.$error" class="messages">
                            <span v-if="!$v.form.companyURL.required">Please type an URL to your public page.</span>
                            <span v-if="!$v.form.companyURL.minLength">Your URL must have at least 3 characters.</span>
                            <span v-if="!$v.form.companyURL.isClean">Your URL must cannot have special characters.</span>
                        </div>
                    </div> -->

                    <div class="row">
                        <div class="col-md-6">
                            <router-link :to="{ name: 'auth.signup.supplier' }">
                                <input type="button" class="btn tertiary widest full" value="Back">
                            </router-link>
                        </div>
                        <div class="col-md-6">
                            <button type="submit" class="btn action widest full" value="Finish" :disabled="!$v.form.$dirty || $v.form.$invalid || submittingRegistration">
                                <loader v-if="submittingRegistration"></loader>
                                <span v-else>Submit</span>
                            </button>
                        </div>
                    </div>

                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import loader from '@/tools/loaders/loader1'
    import { mapActions, mapGetters } from 'vuex'
    import AvatarUploader from '../../common/AvatarUploader'
    import extendedVSelect from '@/extends/vue-select'
    import { required, email, minLength, numeric } from 'vuelidate/lib/validators'

    export default {
        data: function() {
            return {
                step: 2,
                form: {
                    companyEmail: '',
                    companyPhone: '',
                    companyURL: '',
                    imageLogoBase64: null
                },
                selectedOfferType: null,
                submittingRegistration: false,
            }
        },
        validations: {
            form: {
                companyEmail: {
                    //required,
                    email,
                },
                companyPhone: {
                    //required,
                    minLength: minLength(4),
                    // numeric
                },
                // companyURL: {
                //     required,
                //     minLength: minLength(3),
                //     isClean () {
                //         return this.hasNoSpecialChars()
                //     }
                // }
            }
        },
        created: function() {
            // Redirect if we landed here without having passed through the needed steps

            if (this.accountSetup.type !== 'supplier') {
                this.resetAccountSetup('supplier');
                this.$router.push({ name: 'auth.signup' });
            }
            else {
                this.form.tagline = this.accountSetup.tagline || '';
                this.form.companyURL = this.accountSetup.companyURL || '';
                this.eventHub.$emit('sidebar', 'create');
                this.eventHub.$emit('topLink', 'login');
            }
        },
        mounted: function() {
            // this.form.tagline = 'Pluralo is testing';
            // this.form.companyURL = 'pluralo123';
        },
        computed: {
            ...mapGetters([
                'accountSetup'
            ]),
        },
        asyncComputed: {
            async offerTypes() {
                try {
                    let response = await axios.get('/api/settings/GetSupplierOfferTypes');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        this.form.offerType = response.data[0];
                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error.response.data.message);
                }
            },
            brand: function() {
                return this.accountSetup.brand || '';
            }
        },
        methods: {
            ...mapActions([
                'resetAccountSetup',
                'updateAccountSetup',
                'registerSupplier'
            ]),
            // processForm: function() {
            //     this.form.step = this.step + 1;
            //
            //     // Update account setup data
            //
            //     this.updateAccountSetup(this.form);
            //
            //     // Move on to step 3
            //
            //     this.$router.push({ name: 'auth.signup.supplier.finish' });
            // },
            processForm: function() {
                if(!this.submittingRegistration){
                    this.form.step = this.step + 1;

                    // Update account setup data

                    this.updateAccountSetup(this.form);

                    // Create a supplier account via API
                    this.submittingRegistration = true
                    this.registerSupplier({
                        parsed: this.parseQueryString(this.accountSetup),
                        json: this.accountSetup
                    }).then(() => {
                        this.submittingRegistration = false
                        this.resetAccountSetup('supplier');
                    });

                } else {
                    this.$toasted.info('Already submitting your registration, please wait');
                }
            },
            addUploadedAvatar: function(avatar) {
                this.form.imageLogoBase64 = avatar;
            },
            updateOfferType: function() {
                this.form.offerType = this.selectedOfferType.id || null;
            },
            hasNoSpecialChars: function () {
                let stringToTest = this.form.companyURL

                var pattern = new RegExp("^[a-zA-Z0-9_-]*$");
                return pattern.test(stringToTest)
            }
        },
        components: {
            loader,
            vSelect: extendedVSelect,
            AvatarUploader
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// Step2.vue?b76a8456